import React from 'react'
import codes from '../../data/hexcodes';
import HexListItem from '../HexListItem/HexListItem'
import { Row } from 'react-grid-system';

const HexList = sendToApp => (
    <Row nogutter>
            {
                codes.map((code, i) => <HexListItem sendToApp={sendToApp} key={i} code={code} /> )
            }
    </Row>
)

export default HexList


// WEBPACK FOOTER //
// ./src/components/Hexlist/HexList.js